'use client';

import WrongCompanyRequestClient from '@/components/clients/WrongCompanyRequestClient';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface WrongCompanyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function WrongCompanyDialog({ open, onOpenChange }: WrongCompanyDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <WrongCompanyRequestClient onClose={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}

